module.exports = __webpack_public_path__ + "img/gift4-01-c01-t2.54233118.png";